import React from "react";

const Contact = () => {
  return (
    <div className="paragraph-container">
      <h1 className="home-title">Contact Us</h1>
      <p>
        Welcome to our application! We're excited to hear from you. Whether you
        have questions about our services, need assistance, or just want to say
        hello, we're here to help.
      </p>
      <p>
        Email: contact@example.com <br />
        Phone: +1234567890 <br />
        Address: 123 Example Street, City, Country
      </p>
      <h1 >About Our Application</h1>
      <p>
        Our application is designed to provide users with a seamless experience
        for accessing and managing information. Whether you're a new user
        exploring our features or a returning visitor, we strive to make your
        experience enjoyable and productive.
      </p>
      <p>
        If you have any feedback, suggestions, or issues regarding our
        application, please don't hesitate to contact us. Your input is
        invaluable to us as we work to improve and enhance our services.
      </p>
    </div>
  );
};

export default Contact;
